<div class="container import-contract">

  <div class="grid import-contract-section import-contract-section--upload">
    <div class="col-12">
      <h3>Importar Contrato</h3>
    </div>

    <div class="col-12">
      <span>Arquivo:</span>
      <p-fileUpload  chooseLabel="Selecionar" cancelLabel="Cancelar" uploadLabel="Ler Arquivo"
        name="demo[]" url="./upload.php" (onUpload)="onUpload($event)" multiple="multiple"
        accept=".csv, .xls, .xlsx" maxFileSize="1000000" fileLimit="1"
        invalidFileSizeMessageSummary="Tamanho de arquivo inválido"
        invalidFileSizeMessageDetail="Tamanho de arquivo inválido"
        invalidFileTypeMessageSummary="Tipo de arquivo inválido"
        invalidFileLimitMessageDetail="O limite é 1 no máximo"
        invalidFileLimitMessageSummary="Número máximo de arquivos excedido"
        invalidFileTypeMessageDetail="tipos de arquivo permitidos: xls, xlsx e csv"
        >
        <ng-template pTemplate="content">
          @if (uploadedFiles.length) {
            <ul>
              @for (file of uploadedFiles; track file) {
                <li>{{file.name}} - {{file.size}} bytes</li>
              }
            </ul>
          }
        </ng-template>
      </p-fileUpload>
    </div>

    <div class="col-12">
      <button pButton type="button" icon="pi pi-cog" iconPos="left" (click)="bt()">
        {{ 'TRANSLATE.PROCESS.FILE' | translate }}
      </button>
      @if (showProgressBar) {
        <p-progressBar showValue="true" mode="indeterminate" [style]="{'height': '6px'}"></p-progressBar>
      }
    </div>
  </div>

  <div class="grid import-contract-section import-contract-section--results">
    <div class="col-12">
      <p-table #tabela styleClass="app-table app-table--summary">
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5">
              Nenhum contrato encontrado
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th></th>
            <th>País</th>
            <th>Contrato</th>
            <th>Chassi</th>
            <th>Produto</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-lancamento>
          <tr>
            <td>
              <span class="p-column-title">Pessoa</span>
              {{ lancamento.pessoa }}
            </td>
            <td class="col-data">
              <span class="p-column-title">Pagamento</span>
              {{ lancamento.dataPagamento | date:'dd/MM/yyyy' }}
            </td>
            <td class="col-data">
              <span class="p-column-title">Pagamento</span>
              {{ lancamento.dataPagamento | date:'dd/MM/yyyy' }}
            </td>
            <td class="col-valor">
              <span class="p-column-title">Valor</span>
              <span [style.color]="lancamento.tipo === 'DESPESA' ? 'red' : 'blue'">{{ lancamento.valor | number:'1.2-2' }}</span>
            </td>
            <td class="col-acoes">
              <span class="p-column-title"></span>
              <a pButton icon="pi pi-pencil" [pTooltip]="'TRANSLATE.EDIT' | translate" tooltipPosition="top">Editar</a>
              <button pButton icon="pi pi-trash" [pTooltip]="'TRANSLATE.DELETE' | translate" tooltipPosition="top" (click)="confirmarExclusao(lancamento)">Excluir</button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <div class="grid import-contract-section import-contract-section--payments">
    <div class="col-12">
      <form [formGroup]="userform">
        <h4>CRÉDITO</h4>
        <p-fieldset legend="Expandir" [toggleable]="true">
          <table style="width: 100%;" border="0px" >
            <tr >
              <td colspan="2">
                <span style="font-size: 30px;"><br>Cartão de Crédito<br></span>
              </td>
            </tr>
            <tr >
              <td width="50%">
                <span>Número:</span>
              </td>
              <td>
              </td>
            </tr>
            <tr >
              <td >
                <input formControlName="number" [(ngModel)]="cardPagarMeCredit.number" type="text" pInputText width="50%">
              </td>
              <td>
              </td>
            </tr>
            <tr >
              <td >
                <span>Nome impresso no cartão:</span>
              </td>
              <td>
              </td>
            </tr>
            <tr >
              <td >
                <input formControlName="holderName" [(ngModel)]="cardPagarMeCredit.holder_name" type="text" pInputText>
              </td>
              <td>
              </td>
            </tr>
            <tr >
              <td>
                <span>Validade (MM/AA):</span>
              </td>
              <td>
                <span>CVV:</span>
              </td>
            </tr>
            <tr >
              <td>
                <p-inputMask formControlName="expiration" [(ngModel)]="cardPagarMeCredit.exp_year" mask="99/99" ></p-inputMask>
              </td>
              <td>
                <input formControlName="cvv" [(ngModel)]="cardPagarMeCredit.cvv" type="text" pInputText size="5">
              </td>
            </tr>
            <tr >
              <td colspan="2">
                <div class="col-12 import-contract-actions">
                  <button pButton class="ui-button btn-next" (click)="validateCard()" type="button">
                    {{ 'TRANSLATE.FINALIZE.PAYMENT' | translate }}
                  </button>
                </div>
              </td>
            </tr>
          </table>
        </p-fieldset>

        <br>
          <h4>DÉBITO</h4>
          <p-fieldset legend="Expandir" [toggleable]="true">
            <table style="width: 100%;" border="0px" >
              <tr >
                <td colspan="2">
                  <span style="font-size: 30px;"><br>Cartão de Débito<br></span>
                </td>
              </tr>
              <tr >
                <td width="50%">
                  <span>Número:</span>
                </td>
                <td>
                </td>
              </tr>
              <tr >
                <td >
                  <input formControlName="numberDebit" [(ngModel)]="cardPagarMeDebit.number" type="text" pInputText width="50%">
                </td>
                <td>
                </td>
              </tr>
              <tr >
                <td >
                  <span>Nome impresso no cartão:</span>
                </td>
                <td>
                </td>
              </tr>
              <tr >
                <td >
                  <input formControlName="holderNameDebit" [(ngModel)]="cardPagarMeDebit.holder_name" type="text" pInputText>
                </td>
                <td>
                </td>
              </tr>
              <tr >
                <td>
                  <span>Validade (MM/AA):</span>
                </td>
                <td>
                  <span>CVV:</span>
                </td>
              </tr>
              <tr >
                <td>
                  <p-inputMask formControlName="expirationDebit" [(ngModel)]="cardPagarMeDebit.exp_year" mask="99/99" ></p-inputMask>
                </td>
                <td>
                  <input formControlName="cvvDebit" [(ngModel)]="cardPagarMeDebit.cvv" type="text" pInputText size="5">
                </td>
              </tr>
              <tr >
                <td colspan="2">
                  <div class="col-12 import-contract-actions">
                    <button pButton class="ui-button btn-next" (click)="validateDebitCard()" type="button">
                      {{ 'TRANSLATE.FINALIZE.PAYMENT' | translate }}
                    </button>
                  </div>
                </td>
              </tr>
            </table>
          </p-fieldset>

          <br>
            <h4>PIX</h4>
            <p-fieldset legend="Expandir" [toggleable]="true">
              <table style="width: 100%;" border="0px" >
                <tr >
                  <td colspan="2">
                    <span style="font-size: 30px;"><br>PIX<br></span>
                  </td>
                </tr>
                <tr >
                  <td >
                    <span>Informe o Valor do Pix:</span>
                  </td>
                  <td>
                  </td>
                </tr>
                <tr >
                  <td >
                    <input formControlName="pixAmount" [(ngModel)]="itemPagarMe.amount" type="text" pInputText>
                  </td>
                  <td>
                  </td>
                </tr>

                <tr >
                  <td colspan="2">
                    <div class="col-12 import-contract-actions">
                      <button pButton class="ui-button btn-next" (click)="validatePix()" type="button">
                        {{ 'TRANSLATE.FINALIZE.PAYMENT' | translate }}
                      </button>
                    </div>
                  </td>
                </tr>
              </table>


              <div class="grid">
                <div class="col-12">
                  <p-table #tabela [value]="ordersPagarMeResponsePix.charges">
                    <ng-template pTemplate="header">
                      <tr>
                        <th class="table">QRCODE</th>
                        <th class="table">TEXTO</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData>
                      <tr>
                        <td>
                          <img class="chose-plan-image_start" src="{{ rowData.last_transaction.qr_code_url }}" alt="">
                        </td>
                        <td class="col-data">
                          <span class="p-column-title">
                            {{ rowData.last_transaction.qr_code }}
                          </span>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </p-fieldset>
          </form>
        </div>
      </div>

    </div>